import {
  colorBlack,
  colorBlue,
  colorDarkRed,
  colorGray,
  colorGreen,
  colorLightGray,
  colorRed,
  colorWhite,
  colorYellow,
  paletteBlue2,
} from "@/utils/palette";
import { Badge as BootstrapBadge } from "react-bootstrap";
import styled from "styled-components";

const getColor = variant => {
  switch (true) {
    case variant?.includes("gray"):
    case variant?.includes("secondary"):
    case variant?.includes("To Do"):
    case variant?.includes("On Hold"):
      return colorLightGray;
    case variant?.includes("blue"):
    case variant?.includes("Unverified"):
    case variant?.includes("primary"):
    case variant?.includes("None"):
    case variant?.includes("Waiting for support"):
    case variant?.includes("Waiting for customer"):
    case variant?.includes("Bug Fix"):
    case variant?.includes("In Progress"):
    case variant?.includes("Request"):
    case variant?.includes("No Data"):
    case variant?.includes("Waiting for 3rd Party"):
    case variant?.includes("Needs Review"):
    case variant?.includes("Awaiting Implementation"):
    case variant?.includes("awaiting implementation"):
    case variant?.includes("RUNNING"):
    case variant?.includes("In Service"):
    case variant?.includes("In service"):
    case variant?.includes("DEPLOYING"):
    case variant?.includes("Deployed"):
      return colorBlue;
    case variant?.includes("low"):
    case variant?.includes("Low"):
    case variant?.includes("green"):
    case variant?.includes("success"):
    case variant?.includes("Feature"):
    case variant?.includes("Canceled"):
    case variant?.includes("Pending"):
    case variant?.includes("Completed"):
    case variant?.includes("Cancelled"):
    case variant?.includes("Closed"):
    case variant?.includes("Resolved"):
    case variant?.includes("Done"):
    case variant?.includes("Declined"):
    case variant?.includes("Denied"):
    case variant?.includes("PROVISIONING"):
    case variant?.includes("Starting"):
    case variant?.includes("Deleting"):
    case variant?.includes("Updated"):
    case variant?.includes("Attaching Network"):
    case variant?.includes("Yes"):
      return colorGreen;
    case variant?.includes("yellow"):
    case variant?.includes("warning"):
    case variant?.includes("Medium"):
    case variant?.includes("Updating Port Forwarding"):
    case variant?.includes("Updating Service Attributes"):
    case variant?.includes("Updating Networks"):
    case variant?.includes("Clearing Port Forwarding"):
    case variant?.includes("Updating Description"):
    case variant?.includes("RENAMING"):
    case variant?.includes("SCALING"):
    case variant?.includes("30% Complete"):
    case variant?.includes("medium"):
      return colorYellow;
    case variant?.includes("red"):
    case variant?.includes("danger"):
    case variant?.includes("High"):
    case variant?.includes("HIGH"):
    case variant?.includes("Escalated"):
    case variant?.includes("Bug"):
    case variant?.includes("Error"):
    case variant?.includes("Deleted"):
    case variant?.includes("PROLOG_FAILURE"):
    case variant?.includes("Detaching NIC"):
    case variant?.includes("ERROR: DEPLOYING Timeout"):
    case variant?.includes("alert"):
    case variant?.includes("No"):
      return colorRed;
    case variant?.includes("critical"):
    case variant?.includes("Critical"):
    case variant?.includes("highest"):
      return colorDarkRed;
    case variant?.includes("UNKNOWN"):
      return colorBlack;
    case variant?.includes("COOLDOWN"):
      return paletteBlue2;
    case variant?.includes("Open"):
    case variant?.includes("open"):
      return "#595959";
    default:
      return colorLightGray;
  }
};

const Badge = styled(BootstrapBadge)`
  color: ${props =>
    props.bg === "secondary" || props.bg === "gray"
      ? colorGray
      : colorWhite} !important;
  background-color: ${props => getColor(props.bg)} !important;
  font-weight: 500;
  width: ${props => (props.width ? props.width : "auto")};
  height: ${props => (props.height ? props.height : "auto")};
  font-size: ${props => (props.fontSize ? props.fontSize : "12px")};
  white-space: large; /* Allows text to wrap */
  word-wrap: break-word; /* Ensures long words or URLs will break if needed */
`;

export default Badge;
